// extracted by mini-css-extract-plugin
module.exports = {"root":"IconList_root__m0tov","li":"IconList_li__6veNN","small":"IconList_small__mJC1A","circleIcon":"IconList_circleIcon__qRyOc"};